import React from 'react';
import { NavIconKey, getNavIcon } from '../constants/navIcons';

interface NavIconProps {
  name: NavIconKey;
  size?: number;
  className?: string;
}

/** Sidebar nav icon — Material Icons, matched to page headers */
const NavIcon: React.FC<NavIconProps> = ({ name, size = 20, className = '' }) => (
  <span
    className={`material-icons ${className}`.trim()}
    style={{ fontSize: size, width: size, height: size, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
    aria-hidden="true"
  >
    {getNavIcon(name)}
  </span>
);

export default NavIcon;
